import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { GoDownload, GoEye } from "react-icons/go";
import moment from "moment";

const Table = ({
    apiData,

}) => {

    useEffect(() => {
        setCurrentPage(0);
    }, [apiData]);

    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const downloadReport = (report) => {
        window.location.href = report;
    };

    const viewReport = (report) => {
        window.open(
            `https://view.officeapps.live.com/op/embed.aspx?src=${report}`
        );
    };

    const ActionBtns = (item) => {
        return (
            <div className="flex gap-4 ">
                {item.value &&
                    <>
                        <button
                            className={`cursor-pointer text-sm ${'bg-white text-gray-600'}  flex items-center justify-center`}
                            onClick={() => downloadReport(item.value)}
                        >
                            <GoDownload size={16} />
                        </button>
                        {/* <button
                            className={`cursor-pointer text-sm ${'bg-white text-gray-600'}  flex items-center justify-center`}
                            onClick={() => viewReport(item.value)}
                        >
                            <GoEye size={16} />
                        </button> */}
                    </>
                }
            </div>
        );
    };
    const getFormat = (item) => {
        if (item.format === ".xlsx") {
            return "XSLX";
        } else {
            return "CSV";
        }
    };

    const getReport = (item) => {
        if (item.reportType === 1) {
            return "COLLECTIONS";
        } else if (item.reportType === 2) {
            return "DUES";
        } else if (item.reportType === 4) {
            return "EXPENSES";
        } else if (item.reportType === 5) {
            return "ROOMS";
        }
        else if (item.reportType === 6) {
            return "BEDS";
        }
        else if (item.reportType === 7) {
            return "COMPLAINTS";
        }
        else if (item.reportType === 8) {
            return "LEADS";
        }
        else if (item.reportType === 9) {
            return "ACTIVITY LOG";
        }
        else if (item.reportType === 10) {
            return "MOVED OUT TENANTS";
        }
        else if (item.reportType === 11) {
            return "BOOKING";
        }
        else if (item.reportType === 12) {
            return "PROPERTY";
        } else if (item.reportType === 13) {
            return "PROPERTY LEASE";
        } else if (item.reportType === 14) {
            return "REFUND REQUEST";
        } else if (item.reportType === 15) {
            return "RENT REPORT";
        } else if (item.reportType === 17) {
            return "TENANT ATTENDANCE";
        }
        else if (item.reportType === 16) {
            return "P&L REPORT";
        }
         else if (item.reportType === 18) {
            return "HOUSEKEEPING REPORT";
        }
        else {
            return "TENANTS";
        }
    };

    const getStatus = (item) => {
        const isSuccess = item.status === 1;
        const style = isSuccess
            ? "bg-green-100 text-green-600"
            : "bg-rose-100 text-rose-600";
        const label = isSuccess ? "Success" : "Failed";

        return (
            <span className={`${style} px-3 py-1 rounded-md text-sm items-center`}>
                {label}
            </span>
        );
    };

    const getDate = (startDate, endDate, item) => {
        if (item?.reportType === 5 || item?.reportType === 6 || item?.reportType === 13) {
            return "N/A";
        }
        if (startDate && endDate) {
            const formattedStartDate = moment(startDate).format("DD, MMM YY");
            const formattedEndDate = moment(endDate).format("DD, MMM YY");
            return `${formattedStartDate} - ${formattedEndDate}`;
        }
        return "--";
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                createdAt: moment(item.createdAt).format("DD, MMM YY"),
                property: item.propName,
                duration: getDate(item.startDate, item.endDate, item),
                reportType: getReport(item),
                format: getFormat(item),
                status: getStatus(item),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Created On",
                    accessor: "createdAt",
                },

                {
                    Header: "Property",
                    accessor: "property",
                },
            ];
        }
        return [
            {
                Header: "Report Type",
                accessor: "reportType",
            },
            {
                Header: "Property",
                accessor: "property",
            },
            {
                Header: "Duration Covered",
                accessor: "duration",
            },
            // {
            //     Header: "Format",
            //     accessor: "format",
            // },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Created On",
                accessor: "createdAt",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                                style={{ maxWidth: "320px" }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Duration Covered:</strong>{" "}
                                                    {data[rowIndex].duration}
                                                </li>
                                                <li>
                                                    <strong>Report Type:</strong>{" "}
                                                    {data[rowIndex].reportType}
                                                </li>
                                                {/* <li className="flex gap-2">
                                                    <strong>Format:</strong> {data[rowIndex].format}
                                                </li> */}
                                                <li className="flex gap-2">
                                                    <strong>Status:</strong> {data[rowIndex].status}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;

export default Table;
